import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { __Get } from "request/Petitions/__Get";
import environment from "constants/apiConst";

/**
 * Hook para obtener puertos de zona franca (getFreeZonePortNoPaginate)
 * Cachea los datos para evitar peticiones duplicadas
 * 
 * @param {boolean} enabled - Si la query debe ejecutarse (default: true)
 * @returns {Object} Objeto con data, isLoading, error, etc. de React Query
 */
export const useFreeZonePorts = (enabled = true) => {
  const token = useSelector((state) => state.auth.dataUser.token);

  return useQuery({
    queryKey: ["freeZonePorts", "noPaginate"],
    queryFn: async () => {
      const res = await __Get(environment.GET_PORT_NO_PAGE, token);
      return res?.data?.status?.data || [];
    },
    enabled: enabled && !!token,
    staleTime: 1000 * 60 * 10, // 10 minutos - los datos de configuración cambian poco
    gcTime: 1000 * 60 * 30, // 30 minutos en caché
    refetchOnMount: false, // No refetch al montar si los datos están frescos
    refetchOnWindowFocus: false, // No refetch al cambiar de ventana
    retry: 1, // Solo reintentar una vez en caso de error
  });
};
